<template>
  <editor
    id="editor"
    v-model="editorContent"
    @init="editorInit"
    lang="json"
    theme="dracula"
    width="100%"
    :height="height"
  >
  </editor>
</template>
<script>
import editor from 'vue2-ace-editor';

export default {
  components: { editor },
  props: {
    content: {
      type: String,
      required: true
    },
    onChange: {
      type: Function,
      default: () => {}
    },
    height: {
      type: String,
      required: false,
      default: '500'
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    editorContent: {
      get() {
        return this.content;
      },
      set(val) {
        return this.onChange(val);
      }
    }
  },
  methods: {
    editorInit: function(editorInstance) {
      require('brace/ext/language_tools'); //language extension prerequsite...
      require('brace/mode/json'); //language
      require('brace/theme/monokai');
      require('brace/theme/dracula');
      editorInstance.setFontSize('16px');
      editorInstance.setShowPrintMargin(false);
      editorInstance.setOption('readOnly', this.readOnly);
    }
  }
};
</script>
<style scoped></style>
